import React from 'react';
import { Button } from '../components/ui/button';
import { Home, MapPin, Users, Award } from 'lucide-react';
import { villaData } from '../data/mockData';
import { Link } from 'react-router-dom';

export const AboutPage = () => {
  return (
    <div className="min-h-screen pt-24 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Villa Haqqında
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Quba'nın təbii gözəlliklərinin qoynunda yerləşən, müasir və rahat villa
          </p>
        </div>
        
        {/* Main Image */}
        <div className="mb-12 rounded-2xl overflow-hidden shadow-2xl">
          <img
            src={villaData.photos[4]}
            alt="Villa"
            className="w-full h-[500px] object-cover"
          />
        </div>
        
        {/* Content Grid */}
        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          {/* Description */}
          <div className="space-y-6">
            <h2 className="text-3xl font-bold text-gray-900">
              {villaData.name}
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed">
              {villaData.description}
            </p>
            <p className="text-gray-700 leading-relaxed">
              Villamız yeni təmir edilmiş, iki mərtəbəli ev olaraq ailələr və dostlar üçün ideal istirahət məkanıdır. 
              120 m² yaşayış sahəsi və 14 sot torpaq sahəsi ilə geniş və rahat mühit təklif edirik.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Qızdırılan hovuz, geniş meyvə bağı, müasir mətbəx və əyləncə imkanları ilə unutulmaz 
              tətil keçirmək üçün hər şey düşünülüb.
            </p>
          </div>
          
          {/* Quick Facts */}
          <div className="space-y-4">
            <div className="bg-gradient-to-br from-green-50 to-blue-50 p-6 rounded-xl border border-green-100">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                  <Home className="w-6 h-6 text-green-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Mülkiyyət Tipi</h3>
                  <p className="text-gray-600">İki mərtəbəli həyət evi / Villa</p>
                </div>
              </div>
            </div>
            
            <div className="bg-gradient-to-br from-blue-50 to-green-50 p-6 rounded-xl border border-blue-100">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Ünvan</h3>
                  <p className="text-gray-600">{villaData.location}</p>
                </div>
              </div>
            </div>
            
            <div className="bg-gradient-to-br from-green-50 to-blue-50 p-6 rounded-xl border border-green-100">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                  <Users className="w-6 h-6 text-green-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Tutum</h3>
                  <p className="text-gray-600">8-10 nəfər üçün uyğun</p>
                </div>
              </div>
            </div>
            
            <div className="bg-gradient-to-br from-blue-50 to-green-50 p-6 rounded-xl border border-blue-100">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                  <Award className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Xüsusiyyətlər</h3>
                  <p className="text-gray-600">Tam təmirli, təchiz olunmuş, özəl istifadə</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Stats Section */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 text-center">
            <p className="text-4xl font-bold text-green-600 mb-2">3</p>
            <p className="text-gray-600">Yataq Otağı</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 text-center">
            <p className="text-4xl font-bold text-blue-600 mb-2">120 m²</p>
            <p className="text-gray-600">Yaşayış Sahəsi</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 text-center">
            <p className="text-4xl font-bold text-green-600 mb-2">14 sot</p>
            <p className="text-gray-600">Torpaq Sahəsi</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 text-center">
            <p className="text-4xl font-bold text-blue-600 mb-2">6x3.5m</p>
            <p className="text-gray-600">Qızdırılan Hovuz</p>
          </div>
        </div>
        
        {/* CTA */}
        <div className="bg-gradient-to-br from-green-600 to-blue-600 rounded-2xl p-8 lg:p-12 text-center text-white">
          <h2 className="text-3xl font-bold mb-4">Özünüz üçün kəşf edin</h2>
          <p className="text-xl text-green-50 mb-6">Daha ətraflı məlumat və rezervasiya üçün</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/amenities">
              <Button size="lg" className="w-full sm:w-auto bg-white text-green-700 hover:bg-gray-100">
                İmkanları Gör
              </Button>
            </Link>
            <Link to="/contact">
              <Button size="lg" className="w-full sm:w-auto bg-green-800 hover:bg-green-900 text-white">
                Bizimlə Əlaqə
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};